export default __webpack_public_path__ + "static/media/Mic-Input.c6c9c2c6.png";